import type { CSSProperties } from 'vue'

export default function railStyle({
  focused,
  checked,
}: {
  focused: boolean
  checked: boolean
}) {
  const style: CSSProperties = {}
  if (!checked) {
    style.background = 'rgba(240, 160, 32, 0.6)'

    if (focused)
      style.boxShadow = '0 0 0 2px #f0a02040'
  }
  return style
}
